import ArrowIcon from "../../../../../images/left-arrow.png";

export default function Pagination({ changePage, page }) {
  return (
    <div
      style={{
        width: "fit-content",
        margin: "auto 0",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {page.previous && (
        <img
          style={{
            width: "25px",
            height: "fit-content",
            marginLeft: "0",
            marginRight: "auto",
            cursor: "pointer",
          }}
          onClick={() => changePage(-1)}
          src={ArrowIcon}
        />
      )}
      <span style={{ fontWeight: "bold", margin: "auto 10px" }}>
        {page.current + 1}/{page.total}
      </span>
      {page.next && (
        <img
          style={{
            width: "25px",
            height: "fit-content",
            marginLeft: "0",
            marginRight: "auto",
            cursor: "pointer",
            rotate: "180deg",
          }}
          onClick={() => changePage(1)}
          src={ArrowIcon}
        />
      )}
    </div>
  );
}
